<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="row">
      <div class="col-6 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">Template Name</label>
          <p-select
            formControlName="templateId"
            (onChange)="onTemplateSelection()"
            [options]="templates"
            optionValue="id"
            optionLabel="name"
            [showClear]="true"
            [filter]="true">
          </p-select>
        </div>
      </div>
      <div class="col-6 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">PO #</label>
          <p-select
            formControlName="poNumber"
            (onChange)="onPONumberSelection()"
            [options]="poNumber"
            [showClear]="true"
            [filter]="true">
          </p-select>
        </div>
      </div>
      <div class="col-6 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">PO Revision #</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="poNumberRevision" />
        </div>
      </div>
      <div class="col-6 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">Additional Subject</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="additionalSubject"
            (change)="onAdditionalSubject($event)"
            (blur)="logValidationErrors()" />
        </div>
      </div>

      <div class="col-6 col-min-12">
        <div class="row">
          <div class="col-6">
            <div class="form-group has-float-label mt-2">
              <label class="form-label">Sender</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="sender" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group has-float-label mt-2">
              <label class="form-label">Reply</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                placeholder=""
                formControlName="reply" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">Subject</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            formControlName="subject"
            [disabled]="true"
            [ngClass]="{ 'has-error': formErrors['subject'] }"
            (blur)="logValidationErrors()" />

          <span class="error-msg" *ngIf="formErrors['subject']">
            {{ formErrors["subject"] }}
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
